import * as actionTypes from "./LogWorkTypes";

const INITIAL_STATE = {
    logWorkList: [],
    ticketList: [],
    allTicketList: [],
    editorLogWorkData: []
};

const SDLogWorkReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETLOGWORKLIST:
            return {
                ...state,
                logWorkList: action.payload.list
            };
        case actionTypes.SETTICKETLIST:
            return {
                ...state,
                ticketList: action.payload.list
            };
        case actionTypes.SETALLTICKETLIST:
            return {
                ...state,
                allTicketList: action.payload.list
            };
        case actionTypes.SETEDITORLOGWORKDATA:
            return {
                ...state,
                editorLogWorkData: action.payload.list
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                ticketList: null
            };
        default:
            return state;
    }
};

export default SDLogWorkReducer;